// ================================
// Please keep the same naming convention
// used in the design system
// ================================

export enum ColorValue {
  Blue90 = '#3939D8',
  BlueGray90 = '#0E031D',
  BlueGray80 = '#3E354A',
  BlueGray70 = '#564F61',
  BlueGray60 = '#6E6877',
  BlueGray30 = '#B7B3BB',
  BlueGray20 = '#E7E6E8',
  BlueGray05 = '#F3F2F4',
  BlueGray00 = '#FFFFFF',
  Brand90 = '#FFC84E',
  Green90 = '#168756',
  Green20 = '#D0E7DD',
  LightBrand50 = '#FFE3A6',
  Orange90 = '#B35900',
  Orange20 = '#F0DECC',
  Red90 = '#C10000',
  Red20 = '#F3CCCC',
  Wine90 = '#AA0061',
  Wine20 = '#EECCDF',
  Wine500 = '#97225A',
  // Transparencies (update once we can handle transparent colors)
  GreenTransparent = '#ECF5F1',
  BlueGrayTransparency08 = '#ECEBED',
  BlueGrayTransparency04 = '#F5F5F6',
  Black400 = '#4D4D4F'
}

export enum Color {
  // Font colors
  FontPrimary = '#0E031D',
  FontSecondary = '#564F61',
  FontTertiary = '#6E6877',
  FontInverted = '#FFFFFF',
  FontFeedbackPositive = '#168756',
  FontFeedbackWarning = '#B35900',
  FontFeedbackError = '#C10000',

  // Action colors
  ActionQuiteEnabled = '#6E6877',
  ActionPrimaryEnabled = '#3939D8',
  ActionPrimaryDisabled = '#B7B3BB',
  ActionSecondaryEnabled = '#3E354A',
  ActionTertiaryEnabled = '#97225A',

  // Shape colors
  SurfaceFeedbackPositiveLight = '#D0E7DD',
  SurfaceFeedbackWarningLight = '#F0DECC',
  SurfaceFeedbackErrorLight = '#F3CCCC',
  SurfaceInactive = '#F3F2F4',

  // Stroke colors
  StrokeActionPrimaryDefaultFocus = '#EECCDF',
  StrokeActionPrimaryLoudFocus = '#AA0061',

  // Transparencies (update once we can handle transparent colors)
  SurfaceFeedbackPositiveLightTransparent = '#ECF5F1',
  SurfaceInactiveTransparent = '#F5F5F6'
}

export enum ColorType {
  white = 'WHITE',
  black500 = 'BLACK_500',
  orange200 = 'ORANGE_200',
  orange300 = 'ORANGE_300',
  orange500 = 'ORANGE_500',
  yellow300 = 'YELLOW_300',
  yellow500 = 'YELLOW_500',
  yellow700 = 'YELLOW_700',
  green200 = 'GREEN_200',
  green300 = 'GREEN_300',
  green500 = 'GREEN_500',
  green700 = 'GREEN_700',
  black100 = 'BLACK_100',
  black150 = 'BLACK_150',
  black200 = 'BLACK_200',
  black300 = 'BLACK_300',
  black350 = 'BLACK_350',
  red200 = 'RED_200',
  lightBlue300 = 'LIGHT_BLUE_300',
  gold500 = 'GOLD_500',
  pink500 = 'PINK_500',
  blue900 = 'BLUE_900',
  surface = 'SURFACE', // to UI_BG_WHITE
  onSurface = 'ON_SURFACE', // to UI_TEXT_PRIMARY
  uiSuccess = 'UI_SUCCESS', // to UI_FEEDBACK_SUCCESS
  // These colors are ok.
  uiPremium = 'UI_PREMIUM',
  uiOnPremium = 'UI_ON_PREMIUM',
  uiSelected = 'UI_SELECTED', // WINE_500
  uiSelectedVariant = 'UI_SELECTED_VARIANT', // WINE_700
  uiOnSelected = 'UI_ON_SELECTED',
  uiFeedbackError = 'UI_FEEDBACK_ERROR',
  uiFeedbackSuccessLight = 'UI_FEEDBACK_SUCCESS_LIGHT', // GREEN_200
  uiFeedbackCautionLight = 'UI_FEEDBACK_CAUTION_LIGHT',
  uiFeedbackSuccess = 'UI_FEEDBACK_SUCCESS', // GREEN_500
  uiBgBlack = 'UI_BG_BLACK',
  uiBgWhite = 'UI_BG_WHITE',
  uiBgGray = 'UI_BG_GRAY',
  uiBgDarkGray = 'UI_BG_DARK_GRAY',
  uiBgSelected = 'UI_BG_SELECTED',
  uiTextPrimary = 'UI_TEXT_PRIMARY',
  uiTextSecondary = 'UI_TEXT_SECONDARY',
  secondaryVariant = 'SECONDARY_VARIANT',
  uiFeedbackNeutral = 'UI_FEEDBACK_NEUTRAL',
  uiTextInverted = 'UI_TEXT_INVERTED',
  uiTextDisabled = 'UI_TEXT_DISABLED'
}
